import React, {Component} from 'react';
import ReactJWPlayer from 'react-jw-player';
import Header from './Header';

class UpcomingBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countDownTime: '',
            bannerText: ''
        }
    }

    componentDidMount = () => {
        let countDownDate = new Date(this.props.countDownTime);
        let bannerText = `This site will be enabled from
         ${countDownDate.toLocaleString('en-us', {hour:"2-digit", minute:"2-digit"})} on 
         ${countDownDate.toLocaleString('en-us', {year: "numeric", month: 'long', day: 'numeric'})}`
        this.setState({bannerText: bannerText})
        if (this.props.programStatus === 2) {
            let countDownDateMilSecond = countDownDate.getTime();
            let x = setInterval(() => {
                let now = new Date().getTime();
                let diff = countDownDateMilSecond - now;
                let days = Math.floor(diff / (1000 * 60 * 60 * 24));
                let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((diff % (1000 * 60)) / 1000);
                this.setState({countDownTime: `${days}d ${hours}h ${minutes}m ${seconds}s`});
                if (diff < 0) {
                    clearInterval(x);
                    this.setState({countDownTime: `Program Will Start Soon. Please reload browser.`});
                }
            }, 1000);
        }
    }

    render() {
        if(localStorage.programIcon !== "null"){

            let iconEl = document.getElementById('icon');
            iconEl.href = `data:image/jpeg;base64,${localStorage.programIcon}`;

        }
        
        return (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center mt-1 mb-3">
                    {/* <Header></Header> */}
                    
                    {localStorage.programBanner != '' &&
                    
                    <p>
                        <img src={`data:image/jpeg;base64,${localStorage.programBanner}`} className="welcomeBanner" alt="program banner" />
                    </p>

                    }

                    {localStorage.programVideo !== 'null' &&
                    
                    <p>
                        <ReactJWPlayer
                            autoplay
                            file={localStorage.programVideo}
                            key={localStorage.programVideo}
                            playerId='my-id-2231'
                            playerScript='https://cdn.jwplayer.com/libraries/roy564eO.js'
                        />
                    </p>

                    }

                    <br></br>
                    <div className="mb-5">
                        <h3 className='banner-h3'>
                            <span dangerouslySetInnerHTML={{__html: localStorage.programName}}/><br/>
                            {/* <span dangerouslySetInnerHTML={{__html: localStorage.companyName}}/> */}
                        </h3>
                        <h3 className='banner-h3' dangerouslySetInnerHTML={{__html: localStorage.programDate}} />
                    </div>
                    {
                        // this.props.programStatus === 2
                        //     &&
                        //     <>
                        //         <h3 className='banner-h3'>
                        //             {/*This site will be enabled from 02.00 PM on August 13 2020*/}
                        //             {this.state.bannerText}
                        //         </h3>
                        //         <h3>{this.state.countDownTime}</h3>
                        //     </>
                        //     // :
                        //     // <h3 className='text-danger'>Program End</h3>
                    }
                    {
                        this.props.programStatus === 3 
                        ?
                        <>
                            <h3 className='text-danger'>Program Ended</h3>
                            <h4 className='text-center mt-4'>The Recorded/Archived Program will be Shortly Uploaded</h4>
                        </>
                        :
                            <>
                                <h3 className='banner-h3'>
                                    {/*This site will be enabled from 02.00 PM on August 13 2020*/}
                                    {/* {this.state.bannerText} */}
                                    {localStorage.countdownText}
                                </h3>
                                <h3>{this.state.countDownTime}</h3>
                            </>
                    }
                </div>
            </div>
        );
    }
}

export default UpcomingBanner;